import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectDescription from "../ProjectDescription";
import ProjectHeroImage from "../../Projects/ProjectHeroImage";
import SightsImage from "../../../../img/sights.png";
import SightsBG from "../../../../img/sights-bg.png";

const SightsProjectSection = styled(ProjectSection)`
  background: linear-gradient(
      rgba(174, 76, 58, 0.8)
    ),
    url("${SightsBG}");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
`;

function Sights() {
  return (
    <SightsProjectSection>
      <ProjectTitle title="Sights &amp; Sounds" tag="2015" />
      <ProjectSectionSkills>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="HTML">
          <Icons type="html-small" />
        </Badge>
        <Badge small title="Sass">
          <Icons type="sass-small" />
        </Badge>
        <Badge small title="Agile Process">
          <Icons type="agile-small" />
        </Badge>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
      </ProjectSectionSkills>
      <ProjectDescription>
        This site explores the sights and sounds of World War I before, during, and after the war. The client’s focus
        was to present the imagery, video, and audio in an exciting way. My objective was to let the content shine, so
        the design direction centered on a full-screen immersive video that takes over the page seamlessly.
      </ProjectDescription>

      <ProjectHeroImage desktop src={SightsImage} lazy />
    </SightsProjectSection>
  );
}

export default Sights;
